import axios from 'axios';

const url = process.env.REACT_APP_RESTAPI;
const urlV3 = process.env.REACT_APP_RESTAPI_V3;
const wsLogin = process.env.REACT_APP_WEBSOCKET_LOGIN_V3;

export const APIPostLogin = async (setLoading, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/login`, params).catch((error) => error);
    return result;
};

export const APISessionTransferExchange = async (sessionTransferToken, redirectUrl) => {
    const result = await axios.post(
        `${urlV3}/sessionTransfer/exchange`,
        { redirectUrl },
        {
            params: {
                token: sessionTransferToken,
            },
        },
    );
    return result;
};

export const APIWSConnect = async (token, agencyOid) => {
    const result = await axios.post(wsLogin, null, {
        headers: {
            Authorization: token,
            'agency-id': agencyOid,

        },
    }).catch((error) => error);
    return result;
};

export const APIInviteTeam = async (token, agencyId, params) => {
    const result = await axios.post(`${urlV3}/team`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIRequestResetPassword = async (params, setLoading) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/requestResetPassword`, params).catch((error) => error);
    return result;
};

export const APICheckValidPassword = async (params) => {
    const result = await axios.post(`${urlV3}/verifyPasswordOid`, params).catch((error) => error);
    return result;
};

export const APICreateAgency = async (token, agencyId, params) => {
    const result = await axios.post(`${urlV3}/agency`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIUpdateChannel = async (setLoading, token, agencyId, params) => {
    // setLoading(true);
    const result = await axios.post(`${urlV3}/channel`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APITestMessage = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/channel/test`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIVerifyEmail = async (params) => {
    const result = await axios.post(`${urlV3}/verifyEmail`, params).catch((error) => error);
    return result;
};

export const APICreateGeofence = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/geofence`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APICreateDevice = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/devices`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APISignUpUser = async (setLoading, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/signup`, params).catch((error) => error);
    return result;
};

export const APICreateAlertPolicy = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/alertPolicy`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APICreateBatteryPolicy = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/batteryPolicy`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APICreateFuelPolicy = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/fuelPolicy`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

// Adds a vehicle type. System Administrator only (enforced by device-service); 409 on a
// case-insensitive duplicate.
export const APICreateVehicleType = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/vehicleTypes`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APICreateVehicleAdminPreset = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/vehicleAdminPreset`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIPostMaintenanceReceiptOCR = async (setLoading, token, agencyId, payload) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/maintenance/ocr-result`, payload, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    });
    return result;
};

export const APIPostMaintenance = async (setLoading, token, agencyId, payload) => {
    setLoading(true);
    const result = await axios.post(`${urlV3}/maintenance`, payload, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    });
    return result;
};

export const APIPostMaintenanceAttachmentUploadUrl = async (
    token, agencyId, maintenanceId, payload,
) => {
    const encodedId = encodeURIComponent(maintenanceId);
    const result = await axios.post(`${urlV3}/maintenance/${encodedId}/attachments`, payload, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

/** POST /v3/assets/{assetId}/compliance/renew — atomically archive current section and upsert new values. */
export const APIPostAssetComplianceRenew = async (token, setLoading, agencyId, assetId, payload) => {
    setLoading(true);
    const encodedId = encodeURIComponent(assetId);
    const result = await axios.post(`${urlV3}/assets/${encodedId}/compliance/renew`, payload, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    setLoading(false);
    return result;
};
